import React, { Fragment } from 'react';
import { Box, List, ListItem, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import PostCard from '../../../../DesignSystem/PostCard/PostCard';
import ButtonLoadMore from '../../../ButtonLoadMore';
import useSpace from '../../../../../Hooks/useSpace';

function FolderChildrenList({ postsListWithMetadata, parent, label }: any) {
  const { space } = useSpace();
  const { pages, postsCount, paging, isFetching, fetchNextPage } = postsListWithMetadata;

  if (!postsCount) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          mb: 2,
          mt: 1,
        }}
      >
        <Typography variant="h6" component="h2">
          {label}
        </Typography>
      </Box>

      <List disablePadding>
        {pages.map(({ data }: any) => (
          <Fragment key={data.paging.page}>
            {data.data.map((child: any) => (
              <ListItem key={child.id} sx={{ mb: 1 }} disableGutters>
                <PostCard post={child} parent={parent} entity={space} newTab />
              </ListItem>
            ))}
          </Fragment>
        ))}
      </List>

      {!!postsCount && (
        <Box
          sx={{
            mt: 3,
          }}
        >
          <ButtonLoadMore
            onClick={() => fetchNextPage()}
            paging={paging}
            isFetching={isFetching}
            variant="text"
          />
        </Box>
      )}
    </>
  );
}

FolderChildrenList.propTypes = {
  postsListWithMetadata: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
    postsCount: PropTypes.number,
    entity: PropTypes.shape({ id: PropTypes.string }),
    paging: PropTypes.shape({ page: PropTypes.number }),
    isFetching: PropTypes.bool,
  }).isRequired,
  parent: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  label: PropTypes.node.isRequired,
};

export default FolderChildrenList;
